"use client";

import { useMemo } from "react";
import type { Version } from "@/generated/fastapi";
import { optionItemsFactoryFunction } from "@/shared/ui/controls/useOptionItems";
import { getHumanReadableTimestamp } from "@/shared/utils";

export default function useVersionOptions(versions?: Version[] | null) {
  return useMemo(() => {
    const versionItems = optionItemsFactoryFunction<Version>(
      versions ?? [],
      (v) => v.name,
      (v) => v.id,
      (v) =>
        `${v.language.toUpperCase()}${` • ${getHumanReadableTimestamp(
          v.latest_at,
        )}`}`,
    );

    return { versionItems };
  }, [versions]);
}
